import useWindowSize from '../lib/useWindowSize';

export default useWindowSize;
